import { RudderAnalytics } from "@rudderstack/analytics-js";
let instance;
let isInitialized = false;
function load(writeKey, dataPlaneUrl, loadOptions, factory = () => new RudderAnalytics()) {
  if (isInitialized) {
    return;
  }
  instance = factory();
  instance.load(writeKey, dataPlaneUrl, loadOptions);
  isInitialized = true;
}
const track = (eventName, ...properties) => {
  if (!instance) {
    throw new Error(
      `[Charon SDK] Analytics not initialized. Event dropped: ${eventName}`
    );
  }
  instance.track(eventName, ...properties);
};
function consent(options) {
  if (!instance) {
    throw new Error(
      "[Charon SDK] SDK not initialized! You must call load() first."
    );
  }
  instance.consent(options);
}
function client() {
  if (!instance) {
    throw new Error(
      "[Charon SDK] SDK not initialized! You must call load() first."
    );
  }
  return instance;
}
function reset() {
  instance = void 0;
  isInitialized = false;
}
const analytics = {
  load,
  track,
  reset,
  client,
  consent
};
export {
  analytics
};
